import { useModalFocus } from "../accessibility/useModalFocus";

type Props = {
  chipId: string;
  invoke: string;
  revision: number;
  goal?: string;
  bytes: number;
  known: string[];
  open: string[];
  imprints: string[];
  onBack: () => void;
  onConfirm: () => void;
};
export function ContextPreviewSheet({
  chipId,
  invoke,
  revision,
  goal,
  bytes,
  known,
  open,
  imprints,
  onBack,
  onConfirm,
}: Props) {
  const dialogRef = useModalFocus<HTMLDivElement>(".secondary-button");
  return (
    <div
      ref={dialogRef}
      class="overlay-sheet tall"
      role="dialog"
      aria-modal="true"
      aria-labelledby="context-title"
    >
      <span class="sheet-handle" />
      <span class="eyebrow">INVOKE CAPSULE</span>
      <h2 id="context-title">CONTEXT PREVIEW</h2>
      <div class="context-meta">
        HOST CODEX · PROCEDURE {invoke} · CHIP {chipId.toUpperCase()} · REVISION{" "}
        {revision}
      </div>
      <p>GOAL — {goal}</p>
      <div class="context-sections">
        {[
          ["KNOWN", known],
          ["OPEN", open],
          ["IMPRINTS", imprints],
        ].map(([label, entries]) => (
          <div class="context-section" key={label as string}>
            <strong>{label as string}</strong>
            <ul>
              {(entries as string[]).map((entry) => (
                <li key={entry}>{entry}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div class="classification">
        <span>TRUTH — NONE</span>
        <span>RISK — CLEAR</span>
      </div>
      <p class="meta">
        PACKET SIZE — {bytes} B · DEPENDENCIES LOADED — 3 · OMITTED — 11
      </p>
      <p class="meta">Only the displayed context will be exported.</p>
      <div class="sheet-actions">
        <button class="secondary-button" onClick={onBack}>
          BACK
        </button>
        <button class="primary-button" onClick={onConfirm}>
          CONFIRM &amp; INVOKE
        </button>
      </div>
    </div>
  );
}
